import React from 'react'
import HOME_TOPIC_THREE from "../../global/assets/png/Topic-Three.png"
import AtomicButton from '../../atomic/button/AtomicButton'
import { isMobile } from '../../global/ScreenSizeHelper';

const TopicThree = () => {

    if (isMobile) {
        return (
            <>
                Mobile Topic Three
            </>
        )

    }




    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#f6f6f6',
            width: '100%',
            // height: '600px',
            flexWrap: 'wrap'
        }}>

            <div style={{
                width: '65%',
                marginTop: '45px',
                fontSize: '40px',
                fontFamily: 'Inter Medium',
                lineHeight: '50px',
                textAlign: 'center',
                color: '#1B1642',
            }}>
                We invite best chefs from around the globe to serve Local community for a week
            </div>
            <div style={{
                width: '60%',
                textAlign: 'center',
                color: '#1B1642',
                fontFamily: 'Inter Regular',
                fontSize: '20px',
                letterSpacing: '0.4px',
                marginTop: '15px'

            }}>
                It’s more than APIs. Weconnects you to data and
                insights powered by millions of connections, helping you create instant experiences, stop more fraud, and grow revenue.
            </div>

            <div style={{ display: 'flex', position: 'relative', margin: '20px 0px 40px 0px' }}>
                <img alt="" width={600} src={HOME_TOPIC_THREE}  ></img>
            </div>
        </div>
    )
}

export default TopicThree